/* ═══════════════════════════ the shell ═══════════════════════════

   Which tab is showing, and the two functions that answer "something changed —
   redraw whatever is on screen".

   It is a module of its own rather than part of `boot`, because tabs call it.
   The horizon offers a "show me that week" button that switches to the weekly
   tab, and the board, the task panel and the series drawer all invalidate the
   plan and want whichever planning tab is open to catch up. Those are calls
   *into* the shell from below, so the shell has to be importable. */

import { $ } from './dom.js';
import { S, save } from '../state/store.js';
import { renderClock } from './clock.js';
import { renderCalendar } from './calendar.js';
import { renderLongterm } from './longterm.js';
import { renderWeekly } from './weekly.js';

export function showTab(name) {
  S.ui.tab = name; save();
  [...$('tabs').children].forEach((b) => b.classList.toggle('is-active', b.dataset.tab === name));
  document.querySelectorAll('.tab-panel').forEach((p) => p.classList.toggle('is-active', p.id === 'tab-' + name));
  if (name === 'clock') renderClock();
  if (name === 'calendar') renderCalendar();   // the grid needs a laid-out box to size against
  if (name === 'longterm') renderLongterm();   // courses and deadlines may have moved since it last drew
  if (name === 'weekly') renderWeekly();
}

export function initTabs() {
  [...$('tabs').children].forEach((b) => b.addEventListener('click', () => showTab(b.dataset.tab)));
}

/** Redraw whichever planning tab happens to be on screen. Called after any
 *  change that could move a number on one of them. */
export function refreshPlanningTabs() {
  if (S.ui.tab === 'longterm') renderLongterm();
  if (S.ui.tab === 'weekly') renderWeekly();
}
